import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericService } from 'app/_services/generic.service';
import { GroupRolesModel } from './models/group-roles-note-type-model';
import { environment } from "environments/environment";

@Injectable({
  providedIn: 'root'
})
export class GroupRolesService extends GenericService<GroupRolesModel> {
   rootApiUrl: string = environment.Services.AlphaURLSlot2;

  constructor(private http: HttpClient) {
      super(http,'/GroupRoles/', environment.Services.AlphaURLSlot2)
  }
  private generateHeaders() {
    return {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
      }),
    };
  }
  GetByGroupRoleId(groupRoleId) {
    return this.http.post(
      this.url + "GetByGroupRoleId/"+groupRoleId,
      this.generateHeaders()
    );
  }
}